var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#phone_svg__a)",
    d: "M10.063 9.837a1.05 1.05 0 0 0-.465-.774L7.808 7.87A1.06 1.06 0 0 0 6.479 8l-.572.577c-.13.045-.732-.21-1.507-.985s-1.027-1.372-.994-1.49l.587-.588c.354-.354.41-.914.132-1.33L2.93 2.394a1.052 1.052 0 0 0-1.623-.161l-.885.885C-.79 4.332.79 6.998 2.892 9.101c1.43 1.43 4.559 3.895 5.982 2.47l.885-.885a1.05 1.05 0 0 0 .304-.85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#423DCF",
    d: "M6.727 0a.351.351 0 1 0 0 .703c2.52 0 4.57 2.05 4.57 4.57a.351.351 0 1 0 .703 0A5.28 5.28 0 0 0 6.727 0m0 1.406a.351.351 0 1 0 0 .703A3.17 3.17 0 0 1 9.89 5.273a.351.351 0 1 0 .703 0 3.87 3.87 0 0 0-3.867-3.867m0 1.407a.351.351 0 1 0 0 .703c.969 0 1.757.788 1.757 1.757a.351.351 0 1 0 .704 0 2.464 2.464 0 0 0-2.461-2.46m0 1.406a.351.351 0 1 0 0 .703c.194 0 .351.157.351.351a.351.351 0 1 0 .703 0c0-.581-.473-1.054-1.054-1.054"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "phone_svg__a",
    x1: 5.034,
    x2: 5.034,
    y1: 12,
    y2: 1.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5558FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })))));
};
export default SvgPhone;